import {Get, Search, Post, Put} from './server'
import type {Model} from './types'
import type {FilterConfig} from '../components/filters/types'

export const getModels = async (query: FilterConfig) => {
  const filters = query.filters || {}
  const fields = filters.fields || [
    'id',
    'name',
    'description',
    'publisher',
    'score',
    'statistics',
    'cost_per_input_character_usd',
    'cost_per_output_character_usd',
    'cost_per_instance_hour_usd',
    'tokens_cost',
  ]
  const params = {...query, filters: {...filters, fields}}
  return Search('/model', params)
}

export const getModel = async (modelId: string) => Get('/model', {id: modelId})

export const updateModel = async (model: Model) => Put('/model', model)

export const createModel = async (m: Model) => Post('/model', m)

export type CodeParams = {
  stage: 'request' | 'response' | 'grader'
  response?: any
  parsed_response?: any
}
export const testCode = async (code: string, params: CodeParams) =>
  Post('/dsltest', {...params, code})
